export default function NewSmile() {
    return (
        <svg
            width='22'
            height='23'
            viewBox='0 0 22 23'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.989 0.0566406C4.917 0.0566406 0 4.98464 0 11.0566C0 17.1286 4.917 22.0566 10.989 22.0566C17.072 22.0566 22 17.1286 22 11.0566C22 4.98464 17.072 0.0566406 10.989 0.0566406ZM7.15 6.65664C8.063 6.65664 8.8 7.39364 8.8 8.30664C8.8 9.21964 8.063 9.95664 7.15 9.95664C6.237 9.95664 5.5 9.21964 5.5 8.30664C5.5 7.39364 6.237 6.65664 7.15 6.65664ZM11 17.6566C8.492 17.6566 6.358 15.8306 5.5 13.2566H16.5C15.642 15.8306 13.508 17.6566 11 17.6566ZM14.85 9.95664C13.937 9.95664 13.2 9.21964 13.2 8.30664C13.2 7.39364 13.937 6.65664 14.85 6.65664C15.763 6.65664 16.5 7.39364 16.5 8.30664C16.5 9.21964 15.763 9.95664 14.85 9.95664Z'
                fill='white'
            />
        </svg>
    );
}
